<template>
  <section class="max-w-3xl mx-auto px-4 py-10 space-y-8">
    <header class="space-y-2">
      <h1 class="text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-gray-100">Disclaimer</h1>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        Rozay provides Islamic and Ramadan-related content for general informational purposes only.
      </p>
    </header>

    <div class="space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-6">
      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">Timing Disclaimer</h2>
        <p>
          Sehri and Iftar timings may differ slightly from local mosque schedules due to method differences, local
          adjustments, or moon sighting announcements.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">Religious Guidance Disclaimer</h2>
        <p>
          Content about Roza rules, Duas, Fitrana, and Lailat-ul-Qadr is shared for education and awareness. It is not
          a replacement for advice from qualified scholars.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">External Services</h2>
        <p>
          We may use third-party services like Google Analytics and may include Google AdSense in the future. Those
          services may apply their own policies.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">Use at Your Own Judgment</h2>
        <p>
          By using this website, you agree that final religious practice decisions should be confirmed from trusted
          local authorities where needed.
        </p>
      </section>
    </div>
  </section>
</template>
